// PO1-3410: Histórico de Conciliação como linha do tempo (substitui a tabela
// herdada do legado). As regras ficam em historicoConciliacao.js.
import React, { useLayoutEffect, useRef, useState } from "react";

import { StatusBadge, STATUS_TONE } from "./componentesCompartilhados";
import "./styles.css";

// Descrição limitada a poucas linhas; "ver mais" só aparece quando o texto
// realmente passa do limite (mede o conteúdo renderizado, não o tamanho da string).
function DescricaoLimitada({ texto }) {
  const ref = useRef(null);
  const [aberto, setAberto] = useState(false);
  const [excede, setExcede] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || aberto) return undefined;
    const medir = () => setExcede(el.scrollHeight - el.clientHeight > 2);
    medir();
    if (typeof window.ResizeObserver === "undefined") {
      window.addEventListener("resize", medir);
      return () => window.removeEventListener("resize", medir);
    }
    const ro = new window.ResizeObserver(medir);
    ro.observe(el);
    return () => ro.disconnect();
  }, [texto, aberto]);

  if (!texto) return null;
  return (
    <div className="conf-hist-descricao">
      <div
        ref={ref}
        className={`conf-hist-texto${aberto ? "" : " conf-hist-texto--limitado"}`}
      >
        {texto}
      </div>
      {(excede || aberto) && (
        <button
          type="button"
          className="conf-hist-mais"
          onClick={() => setAberto((v) => !v)}
          aria-expanded={aberto}
        >
          {aberto ? "ver menos" : "ver mais"}
        </button>
      )}
    </div>
  );
}

function DetalhesTecnicos({ tecnico }) {
  const [aberto, setAberto] = useState(false);
  if (!tecnico) return null;
  return (
    <div className="conf-hist-tecnico">
      <button
        type="button"
        className="conf-hist-mais"
        onClick={() => setAberto((v) => !v)}
        aria-expanded={aberto}
      >
        {aberto ? "ocultar detalhes técnicos" : "detalhes técnicos"}
      </button>
      {aberto && <pre className="conf-hist-tecnico__texto">{tecnico}</pre>}
    </div>
  );
}

function Evento({ evento, onBaixarAnexo }) {
  const ref = evento.para || evento.de;
  const tom = (ref && STATUS_TONE[ref.codigo]) || "neutral";
  return (
    <li className="conf-hist-evento">
      <span className={`conf-hist-dot conf-fatura-status--${tom}`} aria-hidden="true" />
      <div className="conf-hist-cab">
        <span className="conf-hist-hora">{evento.hora}</span>
        {evento.para && (
          <span className="conf-hist-transicao">
            {evento.de && <span className="conf-hist-de">{evento.de.label}</span>}
            {evento.de && <span className="conf-hist-seta">→</span>}
            <StatusBadge codigo={evento.para.codigo}>{evento.para.label}</StatusBadge>
          </span>
        )}
        <span className="conf-hist-autor">
          {evento.autor}
          {evento.perfil && <span className="conf-hist-perfil"> · {evento.perfil}</span>}
        </span>
      </div>
      <DescricaoLimitada texto={evento.texto} />
      <DetalhesTecnicos tecnico={evento.tecnico} />
      {evento.anexos.length > 0 && (
        <div className="conf-hist-anexos">
          {evento.anexos.map((a) => (
            <button
              key={a.id}
              type="button"
              className="conf-fatura-link conf-fatura-anexo-baixar"
              onClick={() => onBaixarAnexo(a)}
              title={`Baixar ${a.nome}`}
            >
              <i className="tim-icons icon-attach-87" /> {a.nome}
            </button>
          ))}
        </div>
      )}
    </li>
  );
}

export default function LinhaDoTempoConciliacao({ grupos, onBaixarAnexo }) {
  return (
    <div className="conf-hist">
      {grupos.map((g) => (
        <section key={g.dia} className="conf-hist-dia">
          <div className="conf-hist-dia__titulo">{g.dia}</div>
          <ul className="conf-hist-lista">
            {g.eventos.map((e) => (
              <Evento key={e.id} evento={e} onBaixarAnexo={onBaixarAnexo} />
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
